import { graphql } from '@/gql';
import type { ResolveQaCalibrationDisputeMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const resolveQaCalibrationDispute = async (data: ResolveQaCalibrationDisputeMutationVariables['data']) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation ResolveQaCalibrationDispute($data: ResolveQaCalibrationDisputeInput!) {
        resolveQaCalibrationDispute(data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.resolveQaCalibrationDispute;
};
